/** recreate a base manifest with package.json infos
 * standalone class because some logic here (like toLoweCase - name + version etc)
 * 
 * - DOC about manifest https://developer.mozilla.org/fr/docs/Web/Manifest
 */

import packageJson from '../../package.json'
import { slugify } from '../utils/helpers/Strings'
import { locales } from './locales'

const {name, version, description} = packageJson

// optional - max 12char - https://developer.chrome.com/docs/extensions/mv2/manifest/name/#short_name
const short_name = (packageJson as any).short_name || name
const start_url = (packageJson as any).start_url || '/'
const screenshots = (packageJson as any).screenshots || undefined
const background = (packageJson as any).background || '#fff'
const theme_color = (packageJson as any).theme_color || '#fff'

// new for each version...
const id = slugify(`${short_name}-${version}-${Date.now()}`)!
const lang = locales[0]?.code

const manifest:Manifest = {
  id,
  name,
  short_name,
  description,
  lang,
  start_url,
  screenshots,
  background,
  theme_color
}

export default manifest

/* ############################################################################## TYPINGS */

export interface Manifest {
  // idealement contient la version de l'app `koddein-v0.1`
  id: string
  name: string
  short_name: string
  description?: string
  // usually `/`
  start_url?: string
  // primary locale `fr-CA`
  lang?: string,
  screenshots?:PWAScreenshot[],
  // "#fff"
  theme_color?: string,
  // "#fff"
  background?: string,
}

// https://web.dev/patterns/advanced-apps/richer-install-ui/
export type PWAScreenshot = {
  // path from public folder : "/assets/screenshots/default.jpg"
  src: string,
  // ex: "1440x650" /// 320 to 3840 wide | 16/9 = 1.7777... ratio must not exeed 2.3
  sizes: string,
  // jpg/png only
  type: "image/jpeg" | "image/png",
  /* 'wide' = desktop | 'narrow' = mobile
  - All screenshots with the same form factor value must have identical aspect ratios. */
  form_factor?: "wide" | "narrow" | undefined
  label?: string
}
